// https://codepen.io/jemware/pen/ojhCp
import styled from 'styled-components';

const StyledFilterButton = styled.div`

.filter-button{
  position: relative;
  display: inline-block;
  margin: 10px 5px;
}

.filter-button a{
  color:#a86200 !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 26px;
  text-align: center;
  text-decoration:none;
  background-color:#334f51;
  display:block;
  position:relative;
  padding:18px 38px;
  cursor: pointer;
  
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  text-shadow: 0 1px 0 #000;
  filter: dropshadow(color=#000, offx=0px, offy=1px);
  box-shadow:inset 0 1px 0 #FFE5C4, 0 10px 0 #1a3335; !important;
  border-radius: 5px;
  
  @media only screen and (max-width: 624px) {
  font-size: 20px;
  padding: 16px 24px;
  }
  
    @media only screen and (max-width: 400px) {
  font-size: 16px;
  padding: 14px 19px;
  }
  
}

.filter-button.active a{
  top:5px;
  background-color:#1a3335;
  color: orange !important;
  box-shadow:inset 0 1px 0 #467073, inset 0 -3px 0 #1a3335;
}

.filter-button:not(.active) a:hover{
  background-color:#3f5e60; 
  color: orange !important;
}

.filter-button:after{
  content:"";
  height:100%;
  width:100%;
  padding:4px;
  position: absolute;
  bottom:-15px;
  left:-4px;
  z-index:-1;
  background-color:#2B1800;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
`;

export default StyledFilterButton;
